export const GET_ALL_REPORTS = {
  INITIATE: 'GET_ALL_REPORTS_INITIATE',
  SUCCESS: 'GET_ALL_REPORTS_SUCCESS',
  FAILED: 'GET_ALL_REPORTS_FAILED',
};

export const GENERATE_REPORT = {
  INITIATE: 'GENERATE_REPORT_INITIATE',
  SUCCESS: 'GENERATE_REPORT_SUCCESS',
  FAILED: 'GENERATE_REPORT_FAILED',
  CLEAR: 'GENERATE_REPORT_CLEAR',
};

export const getAllReportsInitiate = payload => ({
  type: GET_ALL_REPORTS.INITIATE,
  payload,
});

export const getAllReportsFailed = err => ({
  type: GET_ALL_REPORTS.FAILED,
  err,
});

export const getAllReportsSuccess = reportsData => ({
  type: GET_ALL_REPORTS.SUCCESS,
  reportsData,
});

export const generateReportInitiate = payload => ({
  type: GENERATE_REPORT.INITIATE,
  payload,
});

export const generateReportFailed = err => ({
  type: GENERATE_REPORT.FAILED,
  err,
});

export const generateReportSuccess = generateReportDetails => ({
  type: GENERATE_REPORT.SUCCESS,
  generateReportDetails,
});

export const generateReportClear = () => ({
  type: GENERATE_REPORT.CLEAR,
});
